import React from 'react';
import Helmet from 'react-helmet';
import { Fade } from 'react-reveal';
import Palette from 'react-palette';
import config from '../../config/SiteConfig';
import Footer from '../components/Footer/Footer';
import Container from '../components/Container/Container';
import styles from './project.module.scss';
import Navigation from '../components/Navigation/Navigation';
import EditableText from '../components/EditableText/EditableText';
import StudentsNavGrid from '../components/StudentsNavGrid/StudentsNavGrid';

const Project = props => {
  const { slug } = props.pathContext;
  const postNode = props.data.markdownRemark;
  const project = postNode.frontmatter || {images: []};
  const _formatProject = (project) => {
    project.isSelected = project.node.fields.slug === slug;
    return project;
  };
  const projects = props.data.allMarkdownRemark.edges.map(_formatProject);
  const allImages = project.images;
  const hero = allImages[0] || {publicURL: ''};
  const images = allImages.slice(1, project.images.length).filter(img => img && !!img.publicURL);
  const aboutImg = props.data.imageSharp;
  const instagramLink = `https://instagram.com/${project.instagram.replace('@', '')}`;
  const websiteLink = `http://${project.website}`;

  if (!project.id) {
    project.id = slug;
  }

  let websiteString;
  if (project.website) {
    websiteString = <span>,
          or at <a className={styles.link} href={websiteLink} target="_blank">{project.website}</a>.</span>;
  } else {
    websiteString = <span>.</span>;
  }

  return (
    <div>
      <Navigation projects={projects} aboutImg={aboutImg} isAlwaysPinned={true}/>
      <section className={styles.heroSlide}>
        <div className={styles.imgSlide} style={{ backgroundImage: `url("${hero.publicURL}")`}}></div>
      </section>

      <div className={styles.aboutSection}>
        <div className={styles.about}>
          <h2 className={styles.aboutHeader}>{project.fontName}</h2>
          <p>{project.description}</p>
        </div>

        <div className={styles.about}>
          <h2 className={styles.aboutHeader}>{project.designer}</h2>
          <p>{project.about} You can find {project.title} at <a className={styles.link} href={instagramLink} target="_blank">{project.instagram}</a> on Instagram{websiteString}</p>
        </div>
      </div>

      <div className={styles.typeTester}>
        {project.fonts.map(font => (
            <EditableText
              key={font.name}
              fontName={font.name}
              type={font.type}
              file={font.file}
              uppercaseOnly={font.uppercaseOnly}
              placeholder={font.placeholder}
            />
        ))}
      </div>

      {images.map((img, idx) => (
        <section className={styles.slide} key={idx}>
          <div className={styles.imgSlide} style={{ backgroundImage: `url("${img.publicURL}")` }}></div>
        </section>
      ))}

      <div className={styles.studentsNavContainer}>
        <StudentsNavGrid projects={projects} />
      </div>
    </div>
  );
};

export default Project;

/* eslint no-undef: "off" */
export const pageQuery = graphql`
  query ProjectPostBySlug($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      frontmatter {
        about
        description
        fonts {
          name
          type
          placeholder
        }
        designer
        fontName
        images {
          publicURL
        }
        title
        website
        instagram
      }
    }
    allMarkdownRemark(sort:{fields: [frontmatter___title], order: ASC}) {
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            title
            fonts {
              name
              type
              placeholder
            }
            designer
            fontName
          }
        }
      }
    }
    imageSharp(id: { regex: "/groupPic/" }) {
      sizes(maxWidth: 640) {
        base64
        tracedSVG
        aspectRatio
        src
        srcSet
        srcWebp
        srcSetWebp
        sizes
        originalImg
        originalName
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/project.jsx